import React, { useEffect, useState ,useMemo} from "react";
import api from "../../../apis/api";
import moment from "moment";
import "../../../style/MyAppliedDutyList.css";
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Button,
  Card,
  CardBody,
  Badge,
  Input,
  Label,
} from "reactstrap";

const MyAppliedDutyListModern = () => {
  const [data, setData] = useState([]);

  const [status, setStatus] = useState("All");
  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
const loginUser = JSON.parse(localStorage.getItem("user"));
const currentYear = new Date().getFullYear();
const [selectedYear, setSelectedYear] = useState(currentYear);
const yearOptions = [];
for (let y = currentYear; y >= currentYear - 5; y--) {
  yearOptions.push(y);
}
const yearSelectOptions = useMemo(() => yearOptions.map(y => ({ value: y, label: y })), []);
const yearCustomStyles1 = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: 'transparent',
    border: '1.5px solid rgba(255,255,255,0.6)',
    boxShadow: 'none',
    minHeight: '38px',
    height: '38px',
    width: '110px',
    borderRadius: '6px',
    color: '#fff',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#fff',
    fontWeight: 600,
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#fff',
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#0f9d8a' : state.isFocused ? '#e6f7f4' : '#fff',
    color: state.isSelected ? '#fff' : '#000',
  }),
};
useEffect(() => {
  loadData();
}, [selectedYear, status]);

const loadData = async () => {
  try {
    const fromDate = `${selectedYear}-01-01`;
    const toDate = `${selectedYear}-12-31`;

    const res = await api
      .dbduty()
      .GetDutyApplicationByEmpId(
        parseInt(loginUser.EmployeeId),
        fromDate,
        toDate
      );

    setData(res.data || []);
  } catch (err) {
    console.error("Duty load error:", err);
  }
};

const filtered = data.filter(x => {

  const dutyType = (x.type || "").toLowerCase();
  const searchText = search.toLowerCase();

  const statusMatch =
    status === "All" || x.dutyStatus === status;

  const fromYear = moment(x.fromDate).year();
  const toYear = moment(x.toDate).year();

  const yearMatch =
  fromYear === Number(selectedYear) || toYear === Number(selectedYear);


  const dateMatch =
    (!fromDate || moment(x.fromDate).isSameOrAfter(moment(fromDate))) &&
    (!toDate || moment(x.toDate).isSameOrBefore(moment(toDate)));

  return dutyType.includes(searchText) && statusMatch && yearMatch && dateMatch;
});


  return (
    <div className="duty-modern-page">

      <div className="duty-header">My Applied Duties</div>
 <div className="duty-content">
      <div className="duty-toolbar">
         <input
          type="text"
          placeholder="Search Duty Type"
          onChange={e => setSearch(e.target.value)}
          className="serchtextbox"
        />
<Select
              options={yearSelectOptions}
               classNamePrefix="leave-select"
              value={yearSelectOptions.find(option => option.value === selectedYear)}
              onChange={(selectedOption) => setSelectedYear(selectedOption.value)}
              styles={yearCustomStyles1}
              placeholder="Year"
              isSearchable={false}
              menuPortalTarget={document.body}
            />

      
{/* 
        <input
          type="date"
          placeholder="From Date"
          value={fromDate}
          onChange={e => setFromDate(e.target.value)}
        /> */}
<div className="date-wrapper">
  <DatePicker
    selected={fromDate ? new Date(fromDate) : null}
    onChange={(date) => setFromDate(date)}
    dateFormat="dd-MM-yyyy"
    className="custom-green-datepicker"
    placeholderText="dd-mm-yyyy"
    popperPlacement="bottom-start"
  
  />
</div>
<div className="date-wrapper">
  <DatePicker
    selected={toDate ? new Date(toDate) : null}
    onChange={(date) => setToDate(date)}
    dateFormat="dd-MM-yyyy"
    className="custom-green-datepicker"
    placeholderText="dd-mm-yyyy"
    popperPlacement="bottom-start"
  
  />
</div>
      </div>
 <div className="m-3">
          <Label>Transaction Type</Label>
         <div className="d-flex gap-2 transaction-filter">
  {["All", "Approved", "Pending", "Rejected"].map((s) => {
    const isActive = status === s;

    const bg =
      s === "Approved"
        ? "#2ecc71"
        : s === "Pending"
        ? "#f1c40f"
        : s === "Rejected"
        ? "#e74c3c"
        : "#0f9d8a";

    return (
      <button
        key={s}
        className={`filter-btn ${isActive ? "active" : ""}`}
        style={{

          backgroundColor: isActive ? bg : "#fff",
          color: isActive ? "#fff" : "#333"
        }}
        onClick={() => setStatus(s)}
      >
        {s}
      </button>
    );
  })}
</div>

        </div>


      <div className="duty-table-card">
        <table>
          <thead>
            <tr>
              <th>Duty Type</th>
              <th>Posted on</th>
              <th>From</th>
              <th>To</th>
              <th>Days</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
  {filtered.length === 0 && (
    <tr>
      <td colSpan="6" className="text-center text-muted">
        No Records Found
      </td>
    </tr>
  )}

  {filtered.map((x, i) => (
    <tr key={i}>
      <td>{x.type}</td>
      <td>{moment(x.createdOn).format("DD MMM YYYY")}</td>
      <td>{moment(x.fromDate).format("DD MMM YYYY")}</td>
      <td>{moment(x.toDate).format("DD MMM YYYY")}</td>
      <td>{x.noOfDays}</td>
      <td>
        <Badge
                                style={{
                                  padding: "4px 10px",
                                  borderRadius: "15px",
                                  backgroundColor:
                                    x.dutyStatus === "Approved"
                                      ? "#e6f9f2" /* light green */
                                      : x.dutyStatus === "Pending"
                                      ? "#f9ebc3ff" /* light yellow */
                                      : "#ffe6e6" /* light red */,
                                  color:
                                    x.dutyStatus === "Approved"
                                      ? "#065F46" /* dark green text */
                                      : x.dutyStatus === "Pending"
                                      ? "#92400E" /* dark amber text */
                                      : "#8b0b0b" /* dark red text */,
                                  fontWeight: 600,
                                }}
                              >
                                {x.dutyStatus}
                              </Badge>
        {/* <span className={`badge-${x.dutyStatus.toLowerCase()}`}>
          {x.dutyStatus}
        </span> */}
      </td>
    </tr>
  ))}
</tbody>

        </table>
      </div>
</div>
    </div>
  );
};

export default MyAppliedDutyListModern;
